// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hvJa87AmNX0yMg5zzHqO{flex-direction:column;gap:24px;display:flex}.INlCeFK38yMVgOFcuvdb{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrap": `hvJa87AmNX0yMg5zzHqO`,
	"actionsWrap": `INlCeFK38yMVgOFcuvdb`
};
export default ___CSS_LOADER_EXPORT___;
